import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import I18n from 'apps/new-web/views/components/i18n';

const ActivateTimer = ({ time, gradientColors }) => {
  const [seconds, setSeconds] = useState(time);
  const [hasEnded, setHasEnded] = useState(false);
  const [hasFaded, setHasFaded] = useState(false);
  const ANIMATION = {
    animation: `${time + 2}s linear activate-circle-timer`
  };

  useEffect(() => {
    const decrementTime = setInterval(() => {
      if (seconds > 0 && !hasEnded) {
        setSeconds(seconds => seconds - 1);
      } else {
        if (!hasEnded) {
          setHasFaded(true);
          setHasEnded(true);
          setTimeout(() => {
            setSeconds(time);
            setHasFaded(false);
          }, 500);
        }
      }
    }, 1000);
    return () => clearInterval(decrementTime);
  });

  return (
    <div className="activate-timer">
      <svg className="activate-timer-circles" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" aria-hidden="true" focusable="false">
        <circle className="activate-timer-circle-shadow" cx="50%" cy="50%" r="46" />
        <circle className="activate-timer-circle-color" cx="50%" cy="50%" r="46" stroke="url(#activate-timer-circle-gradient)" style={ ANIMATION } />
        <defs>
          <linearGradient id="activate-timer-circle-gradient">
            {gradientColors.map(color => (<stop key={ color.key } { ...color } /> ))}
          </linearGradient>
        </defs>
      </svg>
      <span className="sr-only"><I18n args={ ({ time }) } >[time] second countdown timer</I18n></span>
      <span className={ hasFaded ? 'activate-timer-circle-text fade-out' : 'activate-timer-circle-text' } aria-hidden="true">{ seconds }</span>
    </div>
  );
};

ActivateTimer.propTypes = {
  time: PropTypes.number,
  gradientColors: PropTypes.array.isRequired
};

ActivateTimer.defaultProps = {
  time: 30
};

export default ActivateTimer;